import useInfiniteDataQuery from '../../../hooks/useInfiniteDataQuery/useInfiniteDataQuery';
import { InfiniteDataQueryFnUtils } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { OmitPaginatedEndpointParams } from '../../types';
import { FindOrderInvoicesParams, findOrderInvoices } from './orderInvoices.repository';

export const useInfiniteOrderInvoicesList = (
  params?: OmitPaginatedEndpointParams<FindOrderInvoicesParams>,
  options?: { isEnabled?: boolean },
) =>
  useInfiniteDataQuery({
    limit: 20,
    queryKey: ['orderInvoices', 'infinite', params],
    defaultOrderBy: { issuedAt: 'DESC' },
    isEnabled: Boolean(params?.orderId) && options?.isEnabled !== false,
    queryFn: InfiniteDataQueryFnUtils.fetcherWithCountAndParams(findOrderInvoices, params || {}),
  });
